import React from "react";
import { MDBDataTableV5 } from "mdbreact";
import { Link } from "react-router-dom";

const HDEDLIST = () => {
  const [datatable, setDatatable] = React.useState({
    columns: [
      {
        label: "Date",
        field: "date",
        width: 120,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
        },
      },
      {
        label: "Dog",
        field: "Breeder",
        width: 270,
      },
      {
        label: "Status",
        field: "Status",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
        },
      },
      {
        label: "Appointment Date",
        field: "Appointment Date",
        width: 270,
      },
      {
        label: "Appointment Time",
        field: "Appointment Time",
        width: 200,
      },
      {
        label: "Appointment Status",
        field: "Appointment Status	",
        sort: "asc",
        width: 100,
      },
      {
        label: "Actions",
        field: "Actions",
        sort: "disabled",
        width: 150,
      },
     
    ],
    rows: [],
  });

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h1>HD/ED Request - List</h1>
        <Link to="create" className="btn btn-primary shadow">
          <i className="fas fa-plus-circle"></i>&nbsp;New
        </Link>
      </div>
      <MDBDataTableV5
        className="shadow mt-2 p-2 rounded "
        hover
        entriesOptions={[10, 20, 25, 50]}
        entries={10}
        pagesAmount={10}
        data={datatable}
        searchTop
        searchBottom={false}
        materialSearch
      />
    </>
  );
};

export default HDEDLIST;
